export const partnersNavigationData = [
  {
    name: 'Green Bay Packers',
    primaryColor: '#06342d',
    link: 'https://packers.bookseats.com/',
  },
  {
    name: 'New York Jets',
    primaryColor: '#115740',
    link: 'https://newyorkjets.bookseats.com/',
  },
  {
    name: 'Houston Texas',
    primaryColor: '#021018',
    link: 'https://houstontexans.bookseats.com/',
  },
  {
    name: 'Vegas Golden Knights',
    primaryColor: '#000000',
    link: 'https://vegasgoldenknights.bookseats.com/',
  },
  {
    name: 'Carolina Hurricanes',
    primaryColor: '#cc0000',
    link: 'https://hurricanes.bookseats.com/',
  },
  {
    name: 'Minnesota Wild',
    primaryColor: '#0e4431',
    link: 'https://wild.bookseats.com/',
  },
  {
    name: 'Utah Utes',
    primaryColor: '#be2025',
    link: 'https://utes.bookseats.com/',
  },
  {
    name: 'New England Revolution',
    primaryColor: '#0E223F',
    link: 'https://revolution.bookseats.com/',
  },
  {
    name: 'Paris La Defense Arena',
    primaryColor: '#3C0A2B',
    link: 'https://parisladefense-arena.bookseats.com/',
  },
]
